<template>
  <div ref="scorll">
    <div class="Home">
      <div class="oldHome" v-if="totalCount>0">
        <div class="title">
          <span>检查作业</span>
        </div>

        <div class="historyHomework" v-if="historyHomework.length" @scroll="handleScroll()" ref="viewWrapper">
          <div class="" v-for="(item,index) in historyHomework" :key="item.id">
            <history :content="item" :delIndex="index" :key="index" @removeWork="removeWork" :PageIndex="PageIndex"></history>
          </div>
          <div class="loading_books" v-if="loading">
            <div class="load_line"></div>
            <p>正在加载中...</p>
          </div>
        </div>

      </div>

      <div class="newHome" v-if="totalCount == 0">
        <div class="noWorkBox">
          <img src="./../assets/img/null.png" class="noGrade">
          <span>您还没有布置过作业呢，赶紧去布置吧</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import history from "./../components/history/history.vue";
import paging from "./../components/paging/paging.vue";
import progressBar from "./../components/progressBar/progressBar.vue";
import fetch from "./../fetch";
import DrawCanvas from "./../unit/progressBar.js";
import {
  nowDate,
  formatDate,
  aroundDate,
  timeStamp,
  formatDataToMinutes,
  closeDateState,
  closeDate
} from "./../filter";

export default {
  data() {
    return {
      showPage: false,
      historyHomework: [],
      isShow: false,
      PageIndex: 1,
      PageCount: 0,
      LastBookArr: [],
      totalCount: 0,
      BookText: "",
      pull_data: true,
      loadMore: true,
      index: 1
    };
  },
  created() {
    // alert("home")
    this.loading = false;
    this.$nextTick(() => {
      this.cleanCatalog();
      this.removeWorks();
      if (
        window.localStorage.user &&
        window.localStorage.user != "underfined"
      ) {
        let user = JSON.parse(window.localStorage.getItem("user"));
        this.setUser(user);
      }
      this.removeCrumb();
      this.setCrumb("首页");
      this.getHomework();
    });
  },
  watch: {
    $attrs(val) {
      if (val.loadMore && val.currentName) {
        this.loading = true;
        this.pull_work();
      }
    }
  },
  methods: {
    ...mapGetters(["getUser"]),
    ...mapActions([
      "setUser",
      "removeCrumb",
      "setCrumb",
      "cleanCatalog",
      "removeWorks"
    ]),


    //收回作业事件
    collectHomework() {
      this.homework();
      this.$toast("收取作业成功", "right");
    },

    arrowShow() {
      if (this.LastBookArr.length <= 2) {
        return;
      }
      this.isShow = true;
      if (this.$refs.swider.style.left == 0) {
        this.$refs.arrowRight.style.display = "block";
        this.$refs.arrowLeft.style.display = "none";
      }
    },

    // 滚动加载更多
    handleScroll() {
      let scrollTop = this.$refs.viewWrapper.scrollTop; //scrollTop为滚动条在Y轴上的滚动距离
      let clientHeight = this.$refs.viewWrapper.clientHeight; //clientHeight为内容可视区域的高度。
      let scrollHeight = this.$refs.viewWrapper.scrollHeight; //scrollHeight为内容可视区域的高度加上溢出（滚动）的距离
      if (scrollTop + clientHeight === scrollHeight) {
        this.loadMore = true;
        this.PageIndex++;
        this.getHomework();
      } else {
        this.loadMore = false;
      }
    },
    //设置请求参数
    setParams() {
      this.params = {
        page: this.PageIndex,
        pageSize: 5
      };
    },
    //先获取到需要参数，再发请求
    getHomework() {
      this.setParams();
      this.homework();
    },
    //发送请求拿布置作业数据
    homework() {
      fetch.homework(this.params).then(res => {
        if (!res) {
          return false;
        }
        this.showPage = true;
        let homeworkData = [];
        // let currentTime = res.data.currentTime
        const currentTime = timeStamp(nowDate());
        let homeworks = [];

        // this.historyHomework = res.data.pageList;
        res.data.pageList.map(item => {
          item.state = closeDateState(
            currentTime,
            item.sendDate,
            item.effectiveDate
          );
          item.stateText = closeDate(
            currentTime,
            item.sendDate,
            item.effectiveDate
          );
          item.isShow_recall = false;
          item.currentTime = currentTime;

          item.workList.forEach(item2 => {
            item2.rush_state = 1;
            item2.rush_result = false;
            item2.currentTime = currentTime;
            item2.effectiveDate = item.effectiveDate;
            item2.sendDate = item.sendDate;
            let submitTotal = 0;
            item2.workContents.forEach(item3 => {
              submitTotal += item3.submitCount;
            });

            if (submitTotal === 0) {
              item2.complete_rate = 0;
              item2.decimals_rate = 0;
            } else {
              item2.decimals_rate = (
                submitTotal /
                (item2.totalNum * item2.workContents.length)
              ).toFixed(2);
              item2.complete_rate =
                (item2.decimals_rate * 100).toFixed(0).toString() + "%";
            }
          });
          homeworks.push(item);
        });
        this.totalCount = res.data.totalCount;
        this.PageCount = Math.ceil(res.data.totalCount / this.params.pageSize);

        // if(this.PageIndex > 1 && !this.pull_data) {
        //   this.historyHomework = this.historyHomework.concat(homeworks);
        // }else{
        //   this.historyHomework = homeworks;
        // }
        this.historyHomework = this.historyHomework.concat(homeworks);
        this.loading = false;
      });
    },
    renderCanvas() {
      let cavnasDoms = document.querySelectorAll("canvas");

      let objName = "canvasThree" + this.index_id;

      cavnasDoms.forEach(dom => {
        // console.log('dom',dom.id)
        let canvasObj = new DrawCanvas(dom.id, this.decimalsRate);
        canvasObj.runCircle();
      });
    },
    removeWork(index, delIndex) {
      this.historyHomework[delIndex].workList.splice(index, 1);
      if (this.historyHomework[delIndex].workList.length <= 0) {
        this.historyHomework.splice(delIndex, 1);
        if (this.historyHomework.length <= 0) {
          this.getHomework();
        }
      }
    }
  },
  components: {
    history,
    paging,
    progressBar,
  }
};
</script>



// WEBPACK FOOTER //
// home.vue?1ad2339e